// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"PD-z","smallCardRow":"QD-z","largeCardRow":"RD-z","productSearchRow":"SD-z","curatedRow":"TD-z"};